import { useLoaderData } from "react-router";
import SimpleFormPage from "../common/SimpleFormPage";
import TagFields from "./TagFields";

export default function EditTag() {
  const data = useLoaderData();
  return (
    <SimpleFormPage title="Modifica tag" loadFn={(form) => form.setFieldsValue(data)}>
      <TagFields />
    </SimpleFormPage>
  );
}
